import React, { ReactElement } from 'react'
import { Col, NavDropdown, Row } from 'react-bootstrap'
import { IconContext } from 'react-icons'
import { Link } from 'react-router-dom'
import { useUserContext } from '../../../context/user/UserProvider'

interface AccountDropdownItemProps {
  label: string
  to: string
  icon: ReactElement
  selected?: boolean
}

const AccountDropdownItem: React.FC<AccountDropdownItemProps> = ({
  label,
  to,
  icon,
  selected,
}) => {
  const { isDarkMode } = useUserContext()

  return (
    <NavDropdown.Item as={Link} to={to}>
      <div
        className={`${
          selected
            ? isDarkMode
              ? 'dm-proline-primary-bg text-light'
              : 'bg-primary text-light'
            : ''
        } rw-account-item border-top border-1 py-3 px-2`}
      >
        <div className="d-flex align-items-center">
          <div className="mx-2">
            <IconContext.Provider value={{ className: 'react-icons' }}>
              {icon}
            </IconContext.Provider>
          </div>
          <div className="ms-2">{label}</div>
        </div>
      </div>
    </NavDropdown.Item>
  )
}

export default AccountDropdownItem
